import React from 'react';

export type RenderProps = {
  categoryIds?: string[];
};

/**
 * HOC.
 * This HOC is used to decorate a component with category ids.
 * @param Component Component that will be decorated with props
 * @param categoryIds ids of categories from the planner config.
 * @returns Component decorated with props
 */
const withCategoryFilter = (categoryIds: string[]) => (
  Component: React.FunctionComponent<RenderProps>
): React.FunctionComponent => (props: any) => <Component {...props} categoryIds={categoryIds} />;
export default withCategoryFilter;
